module.exports = __webpack_public_path__ + "static/media/milk-ring.d8a1ddc1.png";